<template>
  <li class="k-item " @click="handleClick($event, props.dataItem)">
    <span
      class="locatorItemName mt-2"
      role="option"
      :aria-selected="focused"
    >
        <div class="locatorItemNameCell">
              <img v-if="props.dataItem.photoUrl && props.dataItem.showPhoto !== false"
                :src="props.dataItem.photoUrl"
                :alt="t('cart.ConsultantPhotoAlt')"
                class="locatorNamePhoto">
        </div>
        <div class="locatorItemNameCell">
          <div class="row" v-if="props.dataItem.showName !== false">
            <div class="col-12">
                  {{ props.dataItem.name }}
            </div>
          </div>
          <div class="row" v-if="props.dataItem.showLocation !== false">
            <div class="col-12">
                  {{ formatConsultantLocation(props.dataItem) }}
            </div>
          </div>
          <div class="row" v-if="props.dataItem.emailAddress && props.dataItem.showEmail !== false">
            <div class="col-12 locator-item-email">
              ✉ {{ props.dataItem.emailAddress }}
            </div>
          </div>
          <div class="row" v-if="(props.dataItem.mobilePhone && props.dataItem.showMobile !== false) || (props.dataItem.landline && props.dataItem.showLandline !== false)">
            <div class="col-12 locator-item-phone-numbers">
              ☎
              <span v-if="props.dataItem.mobilePhone && props.dataItem.showMobile !== false" class="mr-2">{{ props.dataItem.mobilePhone }} (M)</span>
              <span v-if="props.dataItem.landline && props.dataItem.showLandline !== false">{{ props.dataItem.landline }} (L)</span>
            </div>
          </div>
        </div>
    </span>
  </li>
</template>


<script setup lang="ts">

import { useLogger } from 'vue-logger-plugin'
import { setStoreLogger } from '@/logger.ts'
import { useI18n } from 'vue-i18n'
import type { IConsultantLocator } from '@/types/LocatorTypes';

const { t } = useI18n()

const logger = useLogger()
setStoreLogger(logger)

const props = defineProps<{
    id: string,
    index: number,
    dataItem: IConsultantLocator,
    textField: string,
    focused: boolean,
    selected: boolean
  }>()

logger.debug('AoeConsultantLocatorDetail dataItem', props.dataItem)

const emit = defineEmits(["selectedConsultant", "blur", "focus"]);

function sanitizeLocationPart(value: string | null | undefined): string {
  const trimmedValue = (value ?? '').trim()
  if (!trimmedValue) {
    return ''
  }

  const normalizedValue = trimmedValue.toUpperCase()
  if (normalizedValue === 'N/A' || normalizedValue === 'NA') {
    return ''
  }

  return trimmedValue
}

function sanitizeRegionValue(value: string | null | undefined): string {
  const sanitizedValue = sanitizeLocationPart(value)
  if (!sanitizedValue) {
    return ''
  }

  if (/^\d+$/.test(sanitizedValue)) {
    return ''
  }

  return sanitizedValue
}

function formatConsultantLocation(consultant: IConsultantLocator): string {
  const city = sanitizeLocationPart(consultant.city)
  const region = sanitizeRegionValue(consultant.region)

  if (city && region) {
    return `${city}, ${region}`
  }

  return city || region
}

async function handleClick(event: MouseEvent, dataItem: IConsultantLocator) {
  logger.info('AoeConsultantLocatorDetail.vue', 'handleClick', dataItem)
  emit('selectedConsultant', dataItem)
}



</script>

<style lang="scss">

.locatorItemName
{
  width: 100%;
  display: grid;
  grid-template-columns: 40% 60%;
  padding: $spacing-2-5;

  @include typography-small;
}

.locatorItemNameCell {
  padding: $spacing-1;
}


.locatorNamePhoto {
  width: 50%;
}

@media (max-width: 768px) {
  .locatorItemName {
    grid-template-columns: 30% 70%;
    padding: $spacing-1;
    word-wrap: break-word;

    .locatorNamePhoto {
      height: 80px;
      width: 80px;
      object-fit: cover;
      border-radius: 50%;
    }

    .locator-item-email {
      word-wrap: break-word;
    }

    .locator-item-phone-numbers {
      display: flex;
      flex-direction: column;
    }
  }
}

</style>
